export default function Button({ children, variant = "primary", className, ...props }) {
  const baseStyles =
    "px-6 py-4 font-monoBold text-xs uppercase tracking-wider font-bold transition-all duration-200 ease-out disabled:opacity-40 disabled:cursor-not-allowed active:translate-y-0.5";

  const variants = {
    primary:
      "bg-collectors-black text-white hover:bg-stone-800 border border-solid border-collectors-black hover:-translate-y-1 hover:shadow-[4px_4px_0px_0px_rgba(0,0,0,0.2)]",
    secondary:
      "bg-transparent text-collectors-black border border-solid border-collectors-black hover:bg-collectors-black hover:text-white",
  };

  return (
    <button className={`${baseStyles} ${variants[variant]} ${className || ""}`} {...props}>
      {children}
    </button>
  );
}